<template>
  <div class="createTodo column">
    <div class="topinfo row flex-center">
      <div class="backbtn row flex-center" @click="back()">
        <span class="iconfont icon-arr"></span>
        <span>返回</span>
      </div>
      <div class="flex-1"></div>
      <div>新增待办</div>
    </div>

    <div class="flex-1 overflow-y">
      <!-- <div class="editLine row flex-center">
        <div class="editLine-title">关联好友<span class="fc-red">*</span></div>
        <div class="flex-1">
          <input
            class="inputbox"
            maxlength="32"
            placeholder="请输入姓名"
            v-model.trim="form.friendName"
          />
        </div>
      </div> -->

      <div class="editLine row flex-center">
        <div class="editLine-title">跟进日期 <span class="fc-red">*</span></div>
        <div class="flex-1 row flex-center">
          <div
            class="flex-1 deffont"
            v-if="form.planDate == ''"
            @click="showfollowUpTime()"
          >
            请选择跟进时间
          </div>
          <div class="flex-1" v-else @click="showfollowUpTime()">
            {{ form.planDate }}
          </div>

          <!-- <div
            class="endbtn"
            :class="form.isUnkownBirthday == 1 ? 'active' : ''"
            @click="updateUnknownBirthday"
          >
            未知
          </div> -->
        </div>
      </div>

      <!-- <div class="editLine row flex-center">
        <div class="editLine-title">手机号码<span class="fc-red">*</span></div>
        <div class="flex-1">
          <input
            class="inputbox"
            v-model.trim="form.phone"
            maxlength="11"
            placeholder="请输入手机号码"
            type="number"
            pattern="[0-9]*"
          />
        </div>
      </div> -->

      <div class="editLine row flex-center">
        <div class="editLine-title">跟进类型 <span class="fc-red">*</span></div>
        <div v-if="form.taskType != ''" class="flex-1" @click="showType()">
          {{ form.taskType }}
        </div>
        <div v-else @click="showType()">请选择</div>
      </div>

      <div class="editLine2">
        <div class="editLine-title">跟进内容<span class="fc-red">*</span></div>

        <div class="follCont">
          <input
            class="inputbox"
            maxlength="400"
            placeholder="请输入跟进内容"
            v-model.trim="form.content"
          />
        </div>
      </div>
    </div>

    <div class="saveBtn" @click="createSubmit()">新建</div>
  </div>

  <!--选择时间-->
  <TimeSelect
    v-if="selectTime.isShow"
    :self="selectTime"
    @confirm="timeConfirm"
  >
  </TimeSelect>

  <!--跟进类型下拉-->
  <van-popup
    v-model:show="followupTypeDropdown.isShow"
    position="bottom"
    :style="{ height: '40%' }"
  >
    <van-picker
      title="状态"
      :value="form.taskType"
      :columns="taskTypeOptions"
      @confirm="statusConfirm"
      @cancel="statusCancel"
    />
  </van-popup>
</template>

<script>
import TimeSelect from "@/components/publick/timeSelect.vue";
import moment from "moment";
import func from "@/util/func.js";

import {
  addEnterpriseMicroTodo,
  BoundPatientBasicInfo,
} from "@/api/patient.js";
import { userStore } from "@/store/user";
import { showToast } from "vant";
import { loadingStore } from "@/store/loading.js";

export default {
  name: "toCreate",
  props: [],
  components: {
    TimeSelect,
  },
  data() {
    return {
      form: {
        planDate: "",
        taskType: "跟进提醒",
        patientId: "",
        content: "",
        // followUpTime: '',
        // phone: '',
        // followUpType: '',
        // followUpContent: ''
      },
      followupTypeDropdown: {
        //跟进提醒
        isShow: false,
      },
      taskType: "",
      taskTypeOptions: [{ text: "跟进提醒", value: "跟进提醒" }],

      currentSelectTime: {},
      selectTime: {
        isShow: false,
        minDate: null,
        maxDate: null,
        currentDate: null,
      },
      bindInfo: {
        //企微绑定的患者信息
      },
    };
  },
  mounted() {
    this.getBindInfo();
  },
  setup() {
    let loading = loadingStore();
    return {
      loading,
    };
  },
  methods: {
    back() {
      this.$emit("back");
    },
    getBindInfo() {
      let that = this;
      const aloginStoreuth = userStore();
      BoundPatientBasicInfo({
        corpId: aloginStoreuth.corpId,
        cusId: aloginStoreuth.cusId,
      }).then((res) => {
        that.bindInfo = res.data.data;
        that.form.patientId = res.data.data.id;
      });
    },
    showfollowUpTime() {
      let that = this;
      //this.selectTime.maxDate = new Date(new Date().getFullYear() + 3, new Date().getMonth(), new Date().getDate());

      if (!func.isEmpty(that.form.followUpTime)) {
        this.selectTime.currentDate = [
          moment(that.form.followUpTime).format("YYYY"),
          moment(that.form.followUpTime).format("MM"),
          moment(that.form.followUpTime).format("DD"),
        ];
      }

      this.selectTime.isShow = true;
    },
    timeConfirm(e) {
      let that = this;
      let { valueStr } = e;
      that.currentSelectTime = e;
      that.form.planDate = valueStr;
      //计算 valueStr 时间到现在的间隔年份
    },
    showType() {
      //显示跟进类型
      let that = this;
      that.followupTypeDropdown.isShow = true;
    },
    statusConfirm(value, index) {
      let that = this;
      that.form.taskType = value.selectedValues[0];
      that.followupTypeDropdown.isShow = false;
    },
    statusCancel() {
      let that = this;
      that.followupTypeDropdown.isShow = false;
    },
    createSubmit() {
      let that = this;

      if (func.isEmpty(this.form.planDate)) {
        showToast("请选择跟进日期");
        return;
      }

      // if (func.isEmpty(this.form.phone)) {
      //   showToast("请输入手机号");
      //   return;
      // }

      if (func.isEmpty(this.form.taskType)) {
        showToast("请选择跟进类型");
        return;
      }

      if (func.isEmpty(this.form.content)) {
        showToast("请填写跟进内容");
        return;
      }

      // const phonePattern = /^\d{11}$/;
      // if (!phonePattern.test(this.form.phone)) {
      //   alert("手机号码必须为11位数字！");
      //   return;
      // }

      const aloginStoreuth = userStore();
      let subData = {
        ...that.form,
      };
      that.loading.showLoading();

      addEnterpriseMicroTodo(subData)
        .then((res) => {
          that.$emit("success");
        })
        .finally(() => {
          that.loading.hideLoading();
        });

      // subData.patientId =
    },
  },
};
</script>

<style lang="scss" scoped>
.createTodo {
  text-align: left;
  font-size: 0.292rem;
  box-sizing: border-box;
  flex: 1;
  height: 0;
  padding: 0.25rem;
  background-color: #fff;
}

.backbtn {
  color: #28b8c3;
}

.saveBtn {
  text-align: center;
  background-color: #28b8c3;
  color: #fff;
  padding: 0.208rem;
  border-radius: 0.083rem;
}

.editLine {
  .editLine-title {
    min-width: 1.875rem;
  }
  padding: 0.292rem 0;
  border-bottom: 0.021rem solid #ededed;
}

.editLine2 {
  padding: 0.292rem 0;
  border-bottom: 0.021rem solid #ededed;
}

.follCont {
  padding: 0.125rem 0;
  margin-top: 0.208rem;
}

.inputbox {
  border: none;
  width: 100%;
}
</style>
